(ns dre.pages.dictionary.term-sadv
  (:require
   [clojure.string :as str]
   [dre.pages.dictionary.util :as util]
   [dre.util :refer [not-blank]]))

;; https://docs.drugbank.com/json/#structured-adverse-effects

(defn incidences-item
  [incidences]
  (letfn [(incident [{:keys [kind percent]}]
            (cond-> kind
              (not-blank percent)
              (str " (" (str/replace percent #"%" "") "%)")))]
    [util/list-item-simple (->> incidences (sort-by :kind) (map incident))]))

(def effects-map
  (array-map
   :effect ["Effect" util/object-item]
   :event ["Event" util/str-item]
   :incidences ["Incidences" incidences-item]
    ;:evidence_type ["Evidence type" util/str-item]
   :admin ["Administration" util/str-item]
   :usage ["Usage" util/str-item]
   :associated_with ["Associated with" util/list-item]
   :with_therapy ["With therapy" util/list-item]
   :with_categories ["With categories" util/list-item]
   :patient_characteristics ["Patient characteristics" util/list-item]
   :excluded_patient_characteristics ["Excluded patient characteristics" util/list-item]
   :route ["Route" util/array-item]
   :dose_form ["Dose form" util/array-item]
   :dose_strength ["Dose strength" util/str-item]
   :timeline ["Timeline" util/str-item]
   :regions ["Regions" util/array-item]
   :age_groups ["Age groups" util/array-item]
   :excluded_age_groups ["Excluded age groups" util/array-item]))
